import React from "react";
import { connect } from "react-redux";
import get from "../../utils/get";
import LoginScreen from "../screens/LoginScreen";

import * as actions from "../actions/auth";

const LoginContainer = (props) => {
  return <LoginScreen auth={props.makeLogin} isLoading={props.isLoading} />;
};

const mapStateToProps = (state) => ({
  isLoading: get(state, "login.auth.isLoading"),
});

const mapActionsToProps = { ...actions };

export default connect(mapStateToProps, mapActionsToProps)(LoginContainer);
